export default __webpack_public_path__ + "static/media/logo_heart.6facce05.png";